
import Contact from "@/components/Contact";

const ContactPage = () => {
  return (
    <main className="pt-16">
      <Contact />
    </main>
  );
};

export default ContactPage;
